import { atom, selector } from 'recoil';

import { numberWithSpacesToString } from '@/services/string-format.service';
import {
  BalloonTypes,
  FinanceFilterState,
} from '@/types/filters/filters.types';
import { FinanceCalculation } from '@/types/used-cars/used-cars.types';
import { guardRecoilDefaultValue } from '@/utils/atom';

export const financeFilterState = atom<FinanceFilterState>({
  key: 'financeFilter',
  default: {
    deposit: 0,
    balloon: 0,
    interest: 13.5,
    paymentTerm: 60,
    price: 0,
  },
});

export const activeBalloonOptionState = atom<BalloonTypes>({
  key: 'activeBalloonOption',
  default: BalloonTypes.value,
});

export const financeCalculationState = atom<FinanceCalculation>({
  key: 'financeCalculationState',
  default: {
    monthlyPayment: 0,
    totalRepayment: 0,
    fees: 0,
    registration_fee: 0,
  },
});

export const selectedFinanceFilterState = atom<string>({
  key: 'selectedFinanceFilterState',
  default: '',
});

export const selectedFinanceFilterStateSelector = selector<string | null>({
  key: 'selectedFinanceFilterStateSelector',
  get: ({ get }) => {
    const selectedFinanceFilter = get(selectedFinanceFilterState);

    return selectedFinanceFilter;
  },
  set: ({ set, get }, newValue) => {
    const { monthlyPayment } = get(financeCalculationState);

    if (guardRecoilDefaultValue(newValue)) return;

    if (newValue === '') {
      set(selectedFinanceFilterState, newValue);
      set(financeCalculationState, {
        monthlyPayment: 0,
        totalRepayment: 0,
        fees: 0,
        registration_fee: 0,
      });
      set(financeFilterState, {
        deposit: 0,
        balloon: 0,
        interest: 0,
        paymentTerm: 60,
        price: 0,
      });
      return;
    }
    if (monthlyPayment !== 0 && monthlyPayment) {
      set(
        selectedFinanceFilterState,
        'R' + numberWithSpacesToString(monthlyPayment, '') + ' pm',
      );

      return;
    }

    set(selectedFinanceFilterState, '');
  },
});
